"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGStyles = void 0;
const theme_1 = require("../../theme");
const isInteractive = theme_1.CSSClassBuilder.create(theme_1.ClassNames.isInteractive);
exports.SVGStyles = {
    [theme_1.ClassNames.thumbnailZoomWindow]: {
        stroke: theme_1.StyleConfig.LABEL.STROKE,
        strokeWidth: 5,
        fill: 'rgba(0,0,0,0.35)',
    },
    [theme_1.ClassNames.cropWindow]: {
        stroke: theme_1.StyleConfig.LABEL.STROKE,
        strokeWidth: 5,
        fill: 'rgba(0,0,0,0.0)',
    },
    [theme_1.ClassNames.isThumbnail]: {
        overflow: 'hidden',
    },
    [theme_1.ClassNames.svg]: {
        'max-height': '100%',
        'max-width': '100%',
        overflow: 'hidden',
        'text-rendering': 'optimizeLegibility',
        'font-family': theme_1.StyleConfig.FONT_FAMILY,
        'font-size': theme_1.StyleConfig.FONT_SIZE,
        'user-drag': 'none',
        'user-select': 'none',
        '-moz-user-select': 'none',
        '-webkit-user-drag': 'none',
        '-webkit-user-select': 'none',
        '-ms-user-select': 'none',
    },
    [theme_1.ClassNames.image]: {
        'user-drag': 'none',
        'user-select': 'none',
        '-moz-user-select': 'none',
        '-webkit-user-drag': 'none',
        '-webkit-user-select': 'none',
        '-ms-user-select': 'none',
    },
    [theme_1.ClassNames.isImageLoading]: {
        visibility: 'hidden',
    },
    [theme_1.ClassNames.main]: {
        height: '100%',
    },
    [theme_1.ClassNames.container]: {
        height: '100%',
    },
    'c-Draw-crosshair--outerline': {
        stroke: theme_1.StyleConfig.FONT_COLOR,
    },
    [theme_1.ClassNames.isSelected + ' .' + theme_1.ClassNames.line.secondary]: {
        stroke: 'lime',
    },
    [theme_1.ClassNames.isHighlighted + ' .' + theme_1.ClassNames.line.secondary]: {
        stroke: 'lime',
    },
    [theme_1.ClassNames.label.delete]: {
        cursor: 'pointer',
    },
    [theme_1.ClassNames.label.accept]: {
        cursor: 'pointer',
    },
    [theme_1.ClassNames.isToolActive]: {
        cursor: 'crosshair',
    },
    [theme_1.ClassNames.mask]: {
        // Transformer: #F17F29
        // Streetlight: #F9DC5C
        // Wire: #CA054D
        // DownGuy: #D4C1EC
        // SpanGuy: #8AFFC1
        // Pole: #0267C1
        // Riser: #008000
        // Recloser: #F17F29
        // Capacitor: #F17F29
        // Cutout arrestor: #F17F29
        // Regulator: #F17F29
        // Switch: #F17F29
        // Crossarm: #800080
        opacity: 0.5,
        strokeWidth: 4,
        width: '100%',
        height: 'auto',
        '& .pole': { fill: '#0267C1' },
        '& .transformer': { fill: '#F17F29' },
        '& .streetlight': { fill: '#F9DC5C' },
        '& .wire': {
            fill: '#CA054D',
            stroke: '#CA054D',
        },
        '& .downguy': {
            fill: '#D4C1EC',
            stroke: '#D4C1EC',
        },
        '& .spanguy': { fill: '#8AFFC1', stroke: '#8AFFC1' },
        '& .bounding-box': { fill: 'none', stroke: 'black', strokeWidth: 1 },
        '& .riser': { fill: '#008000' },
        '& .recloser': { fill: '#F17F29' },
        '& .capacitor': { fill: '#F17F29' },
        '& .cutout-arrestor': { fill: '#F17F29' },
        '& .regulator': { fill: '#F17F29' },
        '& .switch': { fill: '#F17F29' },
        '& .crossarm': { fill: '#800080' },
    },
};
// Dont allow creation of new markers on top of labels
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.and(theme_1.ClassNames.isToolActive).child(theme_1.ClassNames.label.container), {
    cursor: 'not-allowed',
});
// Show grab cursor on move
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.child(theme_1.ClassNames.label.container), { cursor: 'grab' });
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.child(theme_1.ClassNames.isMoveable), { cursor: 'grab' });
//CSSClassBuilder.addStyle(SVGStyles, isInteractive.child(ClassNames.cropWindow), { cursor: 'grab' });
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.and(theme_1.ClassNames.isMoving), { cursor: 'grabbing' });
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.and(theme_1.ClassNames.isMoving).child(theme_1.ClassNames.label.container), {
    cursor: 'grabbing',
});
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.and(theme_1.ClassNames.isMoving).child(theme_1.ClassNames.isMoveable), {
    cursor: 'grabbing',
});
// Linking cursor
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.and(theme_1.ClassNames.isLinking).child(theme_1.ClassNames.label.container), {
    cursor: 'alias',
});
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.and(theme_1.ClassNames.isToolActive), { cursor: 'crosshair' });
theme_1.CSSClassBuilder.addStyle(exports.SVGStyles, isInteractive.and(theme_1.ClassNames.isToolActive).child(theme_1.ClassNames.isMoveable), {
    cursor: 'crosshair',
});
//# sourceMappingURL=svg.style.js.map